module.exports = __webpack_public_path__ + "static/media/amex.44c54a9d.svg";